import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Link from "../../../Link";
import styles from "../../styles.pcss";
var cx = classNames.bind(styles);

/**
 * You should not use this component head on, use Description instead
 *
 * Renders single link on the leftSide
 * of Desktop version of Descriptions component
 */
export default function DescriptionMenuitem(_ref) {
  var title = _ref.title,
    isActive = _ref.isActive,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Link, {
    className: cx('navbarLink', {
      active: isActive
    }),
    onClick: onClick,
    "data-t-id": "components-DescriptionMenuitem"
  }, title.replace(/:$/, ''));
}
DescriptionMenuitem.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func
} : {};